import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label,Row, Col} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import Select from '../../../commonComponents/customSelect/CustomSelect.container';
import './SetAccreditationGroupForRequestsModal.css';

class SetAccreditationGroupForRequestsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAccreditationGroupId: ''
        }
    }

    componentWillMount() {
        this.props.onGetAccreditationGroups();
    }

    render() {

        return (
            <Modal className="accreditation-requests-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Label>
                    {_.get(this.props.translation, 'accreditation_requests.set_accreditation_group_for_selected_requests_label')}
                </Label>
                <Row className='accreditation-group-select-container'>
                    <Label for='accreditation-group-select' sm={5}>{_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}</Label>
                    <Col sm={7}>
                        <Select id='accreditation-group-select'
                                selectedOption={_.find(this.props.accreditationGroups, option => option.value === this.state.selectedAccreditationGroupId)}
                                options={this.props.accreditationGroups}
                                onSelect={this.handleChangeSelect}
                                placeholder={_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}
                                disabled={_.isNil(this.props.accreditationGroups)}
                        />
                    </Col>
                </Row>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            disabled={_.isEmpty(this.state.selectedAccreditationGroupId)}
                            onClick={this.handleReject}>{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </div>
        );
    }

    handleChangeSelect = (selectedOption) => {
        this.setState({selectedAccreditationGroupId: selectedOption.value});
    };

    handleReject = (e) => {
        e.preventDefault();

        this.props.onSetAccreditationGroup(this.state.selectedAccreditationGroupId);
        this.props.onCancel();
    };

    handleCancel = () => {
        this.props.onCancel();
    };
}

SetAccreditationGroupForRequestsModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    accreditationGroups: PropTypes.array,
    onSetAccreditationGroup: PropTypes.func,
    onCancel: PropTypes.func,
    onGetAccreditationGroups: PropTypes.func
};

export default SetAccreditationGroupForRequestsModal;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/setAccreditationGroupForRequestsModal/SetAccreditationGroupForRequestsModal.js